"use client";

import { c as _c } from "react/compiler-runtime";
import Back from "@modules/common/icons/back";
import FastDelivery from "@modules/common/icons/fast-delivery";
import Refresh from "@modules/common/icons/refresh";
import Accordion from "./accordion";
import { HttpTypes } from "@medusajs/types";
import { Text } from "@medusajs/ui";
import Image from "next/image";
import { PiShoppingBag, PiCreditCard, PiPackage, PiArrowCounterClockwise, PiChatCircleDots } from "react-icons/pi";
import RatingStars from "@modules/reviews/components/rating-stars";
type ProductTabsProps = {
  product: any;
};
const ProductTabs = t0 => {
  const $ = _c(42);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product) {
    t1 = Array.isArray(product?.infoIds) && product.infoIds.some(_temp);
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasAdditionalInfo = t1;
  let t2;
  if ($[2] !== product) {
    t2 = <HowToBuy product={product} />;
    $[2] = product;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PiShoppingBag className="w-5 h-5 text-black self-center" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      label: "C\xF3mo Comprar",
      component: t2,
      icon: t3
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== product) {
    t5 = <ShippingInfoTab product={product} />;
    $[7] = product;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PiPackage className="w-5 h-5 text-black self-center" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = {
      label: "Env\xEDo y Entrega",
      component: t5,
      icon: t6
    };
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== product) {
    t8 = <PaymentMethods product={product} />;
    $[12] = product;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <PiCreditCard className="w-5 h-5 text-black self-center" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = {
      label: "Formas de Pago",
      component: t8,
      icon: t9
    };
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== product) {
    t11 = <ReturnPolicyTab product={product} />;
    $[17] = product;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PiArrowCounterClockwise className="w-5 h-5 text-black self-center" />;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11) {
    t13 = {
      label: "Pol\xEDtica de Devoluciones",
      component: t11,
      icon: t12
    };
    $[20] = t11;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== product) {
    t14 = {
      label: "\xBFNecesit\xE1s ayuda con tu compra?",
      component: <HelpTag product={product} />
    };
    $[22] = product;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== product) {
    t15 = <ProductReviewsTab product={product} />;
    $[24] = product;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PiChatCircleDots className="w-5 h-5 text-black self-center" />;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15) {
    t17 = {
      label: "Rese\xF1as",
      component: t15,
      icon: t16
    };
    $[27] = t15;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== hasAdditionalInfo || $[30] !== product) {
    t18 = hasAdditionalInfo ? [{
      label: "Gu\xEDa de Talles",
      component: <ProductAdditionalInfoTab product={product} />,
      icon: <Refresh />
    }] : [];
    $[29] = hasAdditionalInfo;
    $[30] = product;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t10 || $[33] !== t13 || $[34] !== t14 || $[35] !== t17 || $[36] !== t18 || $[37] !== t4 || $[38] !== t7) {
    t19 = [t4, t7, t10, t13, t14, t17, ...t18];
    $[32] = t10;
    $[33] = t13;
    $[34] = t14;
    $[35] = t17;
    $[36] = t18;
    $[37] = t4;
    $[38] = t7;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  const tabs = t19;
  let t20;
  if ($[40] !== tabs) {
    t20 = <div className="w-full"><Accordion type="multiple">{tabs.map(_temp2)}</Accordion></div>;
    $[40] = tabs;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
};
const ProductReviewsTab = t0 => {
  const $ = _c(21);
  const {
    product
  } = t0;
  const summary = product?.reviewSummary;
  let t1;
  if ($[0] !== product) {
    t1 = Array.isArray(product?.recentReviews) ? product.recentReviews : [];
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reviews = t1;
  const average = typeof summary?.averageOverall === "number" && summary.averageOverall > 0 ? summary.averageOverall : typeof summary?.bayesianAverageOverall === "number" ? summary.bayesianAverageOverall : 0;
  const totalReviews = typeof summary?.totalReviews === "number" ? summary.totalReviews : 0;
  if (!summary || totalReviews === 0) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="py-6"><p className="text-sm text-gray-600">Todavía no hay reseñas para este producto.</p></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== average) {
    t2 = <RatingStars value={average} size="md" readOnly={true} />;
    $[3] = average;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== average) {
    t3 = average.toFixed(1);
    $[5] = average;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = totalReviews === 1 ? "" : "s";
  let t5;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== totalReviews) {
    t5 = <span className="text-base font-semibold text-black">{t3} · {totalReviews} reseña{t4}</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = totalReviews;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex flex-wrap items-center gap-3">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== reviews) {
    t7 = reviews.length === 0 ? <p className="text-sm text-gray-600">No hay reseñas recientes.</p> : reviews.map(_temp3);
    $[14] = reviews;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="grid gap-4">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="space-y-4 py-6">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
const PaymentMethods = t0 => {
  const $ = _c(16);
  const {
    product
  } = t0;
  const displayName = product?.name ?? product?.title ?? "este producto";
  const brandName = product?.brand?.name ?? "la marca";
  const t1 = `Puedes comprar ${displayName} de ${brandName} pagando con todas las tarjetas de crédito y débito, transferencia bancaria o métodos de pago en efectivo.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="max-w-full font-lealti-light text-black">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#1434CB" /><path d="m16.4161 7.21719-1.9594 9.41161h-2.3794l1.9595-9.41161h2.3793Zm9.8674 6.08131 1.2597-3.54741.6998 3.54741h-1.9595Zm2.6593 3.3303h2.1694l-1.8895-9.41161h-2.0294c-.4199 0-.8398.28959-.9798.72397l-3.499 8.68764h2.4493l.4899-1.3755h3.0092l.2799 1.3755Zm-6.1584-3.1131c0-2.4615-3.2891-2.6063-3.2891-3.69222.07-.50678.4899-.79636.9798-.79636.7697-.0724 1.6095.07239 2.3093.43438l.4199-2.02712C22.5045 7.14479 21.7347 7 21.0349 7c-2.3094 0-3.9889 1.30315-3.9889 3.1131 0 1.3755 1.1897 2.0995 2.0294 2.5339.9098.4343 1.2597.7239 1.1897 1.1583 0 .6516-.6998.9412-1.3996.9412-.8398 0-1.6796-.2172-2.4494-.5792l-.4198 2.0271c.8397.362 1.7495.5068 2.5893.5068 2.5893.0724 4.1988-1.2308 4.1988-3.1855ZM13.057 7.21719 9.27805 16.6288H6.75873l-1.8895-7.52929c0-.36198-.27992-.65157-.55985-.79636C3.60957 7.94116 2.83978 7.65157 2 7.50678l.06998-.28959h3.98893c.55985 0 .97974.43438 1.04972.94116l.97974 5.42975 2.51933-6.37091h2.4493Z" fill="#fff" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 0H4C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4Z" fill="#000" /><path d="M21.8342 19.4082c4.0195 0 7.278-3.2585 7.278-7.2781 0-4.01955-3.2585-7.27805-7.278-7.27805-4.0196 0-7.2781 3.2585-7.2781 7.27805 0 4.0196 3.2585 7.2781 7.2781 7.2781Z" fill="#F9A000" /><path d="M12.1301 19.4082c4.0195 0 7.278-3.2585 7.278-7.2781 0-4.01955-3.2585-7.27805-7.278-7.27805-4.01957 0-7.27806 3.2585-7.27806 7.27805 0 4.0196 3.25849 7.2781 7.27806 7.2781Z" fill="#ED0006" /><path fillRule="evenodd" clipRule="evenodd" d="M16.9833 6.7063c1.4883 1.33263 2.4248 3.26885 2.4248 5.4238 0 2.155-.9365 4.0912-2.4248 5.4238-1.4902-1.3317-2.4272-3.2683-2.4272-5.4238 0-2.0902.8811-3.97453 2.2921-5.30196l.1351-.12184Z" fill="#FF5D00" /></svg>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 0H4C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4Z" fill="#000" /><path d="M21.9821 19.3061c4.0196 0 7.2781-3.2585 7.2781-7.278 0-4.01961-3.2585-7.2781-7.2781-7.2781-4.0195 0-7.278 3.25849-7.278 7.2781 0 4.0195 3.2585 7.278 7.278 7.278Z" fill="#00A1DF" /><path d="M12.2781 19.3061c4.0195 0 7.278-3.2585 7.278-7.278 0-4.01961-3.2585-7.2781-7.278-7.2781C8.25849 4.75 5 8.00849 5 12.0281c0 4.0195 3.25849 7.278 7.2781 7.278Z" fill="#EB001B" /><path fillRule="evenodd" clipRule="evenodd" d="M17.1312 6.60425c1.4883 1.33263 2.4249 3.26885 2.4249 5.42385 0 2.1549-.9366 4.0912-2.4249 5.4238-1.4901-1.3318-2.4271-3.2684-2.4271-5.4238 0-2.0902.8811-3.97458 2.2921-5.30201l.135-.12184Z" fill="#7673C0" /></svg>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.1184 0H3.88163C1.73786 0 0 1.73786 0 3.88163V20.1184C0 22.2621 1.73786 24 3.88163 24H30.1184C32.2621 24 34 22.2621 34 20.1184V3.88163C34 1.73786 32.2621 0 30.1184 0Z" fill="#016FD0" /><path d="M3.56625 8.1438 2 11.893h1.01971l.28899-.7507h1.68005l.2875.7507h1.04217L4.75367 8.1438H3.56625Zm.57948.87256.5121 1.31194h-1.0257l.5136-1.31194ZM6.42631 11.8921V8.14282l1.44906.00554.84282 2.41724.82264-2.42278h1.43747v3.74928h-.9104V9.12947l-.96504 2.76263h-.79842l-.96773-2.76263v2.76263h-.9104ZM11.6011 11.8921V8.14282h2.9708v.83865h-2.0508v.64131h2.0029v.78932h-2.0029v.666h2.0508v.814h-2.9708ZM15.099 8.14331v3.74919h.9104v-1.3319h.3834l1.0915 1.3319h1.1126l-1.1979-1.3812c.4916-.0428.9988-.4772.9988-1.15164 0-.78897-.6015-1.21635-1.2728-1.21635h-2.026Zm.9104.83864h1.0407c.2497 0 .4313.20106.4313.39466 0 .24908-.2353.39466-.4178.39466h-1.0542v-.78932ZM19.699 11.8921h-.9296V8.14282h.9296v3.74928ZM21.9031 11.8921h-.2007c-.9708 0-1.5602-.7875-1.5602-1.8592 0-1.09826.5828-1.89008 1.8088-1.89008h1.0062v.88798h-1.043c-.4977 0-.8497.39987-.8497 1.0113 0 .7261.4025 1.0311.9823 1.0311h.2396l-.3833.8189ZM23.8841 8.14331l-1.5662 3.74919h1.0197l.289-.7507h1.68l.2875.7507h1.0422l-1.5648-3.74919h-1.1874Zm.5795.87256.5121 1.31193H23.95l.5136-1.31193ZM26.7426 11.8921V8.14282H27.9l1.4779 2.35558V8.14282h.9104v3.74928h-1.12L27.653 9.47479v2.41731h-.9104ZM7.582 16.7133v-3.7492h2.9708v.8386H8.50198v.6414h2.00282v.7893H8.50198v.6659h2.05082v.814H7.582ZM22.1387 16.7133v-3.7492h2.9707v.8386h-2.0507v.6414h1.9932v.7893h-1.9932v.6659h2.0507v.814h-2.9707ZM10.668 16.7133l1.4465-1.8515-1.4809-1.8977h1.1469l.882 1.1732.8849-1.1732h1.1021l-1.4614 1.8746 1.4491 1.8746h-1.1468l-.8564-1.1547-.8355 1.1547H10.668ZM14.7452 12.9648v3.7492h.9344v-1.1839h.9583c.8109 0 1.4255-.4429 1.4255-1.3042 0-.7135-.4821-1.2611-1.3072-1.2611h-2.011Zm.9344.8479h1.0092c.262 0 .4492.1653.4492.4317 0 .2502-.1863.4316-.4522.4316h-1.0062v-.8633ZM18.4587 12.9641v3.7492h.9104v-1.3319h.3833l1.0916 1.3319h1.1125l-1.1979-1.3813c.4916-.0427.9987-.4771.9987-1.1516 0-.7889-.6014-1.2163-1.2727-1.2163h-2.0259Zm.9104.8386h1.0406c.2497 0 .4313.2011.4313.3947 0 .2491-.2353.3947-.4178.3947h-1.0541v-.7894ZM25.531 16.7133v-.814h1.822c.2695 0 .3863-.1499.3863-.3144 0-.1577-.1164-.317-.3863-.317h-.8234c-.7156 0-1.1142-.4489-1.1142-1.1229 0-.6012.365-1.1809 1.4285-1.1809h1.7728l-.3833.8436h-1.5333c-.2931 0-.3833.1583-.3833.3095 0 .1555.1115.3269.3354.3269h.8625c.7978 0 1.144.4659 1.144 1.076 0 .656-.3858 1.1932-1.1875 1.1932H25.531ZM28.8723 16.7133v-.814h1.822c.2696 0 .3863-.1499.3863-.3144 0-.1577-.1164-.317-.3863-.317h-.8234c-.7156 0-1.1142-.4489-1.1142-1.1229 0-.6012.365-1.1809 1.4285-1.1809h1.7728l-.3833.8436h-1.5333c-.2931 0-.3833.1583-.3833.3095 0 .1555.1115.3269.3354.3269h.8625c.7978 0 1.144.4659 1.144 1.076 0 .656-.3858 1.1932-1.1874 1.1932h-1.9403Z" fill="#fff" /></svg>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 0H4C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4Z" fill="#FFA201" /><path d="m14.1089 9.79783.1561.00638c.3396 0 .7278.04852 1.0189.24259v.9704c-.2426-.2911-.6308-.4852-1.0189-.4852-.7763.0485-1.4071.7278-1.3586 1.5041v.0971c0 .7763.6308 1.3586 1.4071 1.3586.3882 0 .7278-.1941.9704-.4853v.9705c-.3396.1455-.6793.2426-1.0674.2426-1.213 0-2.1835-1.019-2.1835-2.232 0-1.2615.9705-2.28043 2.232-2.18339l-.1561-.00638Zm6.6578.00638 1.116 2.91119 1.1645-2.91119h.8733l-1.7952 4.41539h-.4367l-1.7953-4.41539h.8734Zm-10.5095-.09942.1262.00238c.4366 0 .8733.19408 1.213.48523l-.4367.5822c-.1941-.1941-.4367-.3396-.6793-.3396-.2911-.0485-.53373.1941-.58225.4852 0 .2426.14555.3396.63075.5337.9704.3882 1.213.6793 1.2615 1.2615v.1456c-.0485.7763-.6792 1.3586-1.4556 1.31-.58221 0-1.16446-.2911-1.45558-.8248l.53373-.5337c.14556.3396.4852.5822.87335.5822h.0485c.2912 0 .5823-.2911.5823-.6308 0-.194-.0971-.3396-.2426-.4366-.1941-.0971-.3882-.1941-.5823-.2426-.7763-.2426-1.0189-.5823-1.0189-1.1645v-.0485c.04852-.6793.63077-1.21305 1.3101-1.16453l-.1262-.00238Zm-4.91996.09942c1.16448.04852 2.08637 1.01889 2.03785 2.18339 0 .6308-.29112 1.213-.77632 1.6497-.43669.3397-.97041.5337-1.50413.4852H3.88163V9.80421h1.45561Zm3.20234 0v4.31829h-.82485V9.80421h.82485Zm18.09812 0v.72779h-1.5042v.9704h1.4556v.7278h-1.4556v1.1645h1.5042v.7278h-2.329V9.80421h2.329Zm1.7467 0c.9704 0 1.5041.43669 1.5041 1.26149.0486.6308-.3881 1.1645-.9704 1.2616l1.3101 1.7952h-1.019l-1.1159-1.7467h-.0971v1.7467h-.8248V9.80421h1.213Zm-23.28787.71849-.14746.0093h-.2426v2.8627h.2426c.38817.0485.82485-.097 1.11597-.3396.29112-.2912.43668-.6793.43668-1.116 0-.3882-.14556-.7763-.43668-1.0674-.29112-.2426-.7278-.3882-1.11597-.3397l.14746-.0093Zm23.14227-.0392h-.2426v1.31h.2426c.5338 0 .7764-.2426.7764-.6792 0-.3882-.2426-.6308-.7764-.6308Z" fill="#fff" /><path opacity=".8" d="M17.807 9.75562c-1.213 0-2.232.97038-2.232 2.23198 0 1.213.9704 2.2319 2.232 2.2804 1.2615.0485 2.2319-.9704 2.2804-2.2319-.0485-1.2616-1.0189-2.28048-2.2804-2.28048Z" fill="#fff" /></svg>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#fff" /><path fillRule="evenodd" clipRule="evenodd" d="M30 1H4C2.34315 1 1 2.34315 1 4v16c0 1.6569 1.34315 3 3 3h26c1.6569 0 3-1.3431 3-3V4c0-1.65685-1.3431-3-3-3ZM4 0C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4H4Z" fill="#C4CCD8" /><path d="M4.85204 6.01643v7.76327c.77632.4852 1.64969.7763 2.62009.7763.87337 0 1.55266-.6793 1.6497-1.5526V8.73357h2.62007v4.07573c0 1.5526-.8733 2.9112-3.68752 2.9112-1.06745 0-2.1349-.1941-3.1053-.3882v6.0166h4.65795c1.74677 0 3.10527-1.3586 3.10527-3.1053V2.91113H7.95734c-1.74674 0-3.1053 1.35857-3.1053 3.1053Z" fill="#1B6BAF" /><path d="M16.691 2.91113c-1.7467 0-3.1053 1.35857-3.1053 3.1053v3.68755c.7763-.77632 2.1349-1.26153 4.3668-1.16449.8734.09704 1.6497.19408 2.426.38817v1.45564c-.6792-.3882-1.5526-.67932-2.3289-.77636-1.3586-.09704-2.5231.87336-2.7172 2.13486-.097 1.3586.8734 2.5231 2.1349 2.7172h.4852c.8734-.0971 1.6497-.3882 2.329-.7764v1.4557c-.7763.194-1.6497.3881-2.426.3881-2.2319.0971-3.5905-.3881-4.3668-1.1645v6.7929h4.6579c1.7467 0 3.1053-1.3586 3.1053-3.1053V2.91113H16.691Z" fill="#D02644" /><path d="M25.4247 2.91113c-1.7468 0-3.1053 1.35857-3.1053 3.1053v2.71714h4.755c.8733-.09704 1.6496.67929 1.7467 1.55263v.0971c0 .8733-.5823 1.5526-1.4556 1.6497.9704 0 1.7467.7763 1.8437 1.7467 0 .9704-.8733 1.7467-1.8437 1.7467h-5.0461v5.8225h4.5609c1.7467 0 3.1053-1.3586 3.1053-3.1053V2.91113h-4.5609ZM24.2602 14.459h2.2319c.4852-.1941.7763-.6793.6793-1.2616-.097-.2911-.3882-.5822-.6793-.6792h-2.2319v1.9408Zm2.7171-3.8817c0-.3881-.2911-.77628-.6793-.87332h-2.0378v1.74672h2.0378c.3882-.097.6793-.4852.6793-.8734Z" fill="#46A548" /></svg>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#0079BE" /><path d="M18.8314 19.9999c4.3729.0209 8.3644-3.5664 8.3644-7.9304 0-4.77238-3.9915-8.07109-8.3644-8.0695h-3.7635C10.6425 3.99841 7 7.29811 7 12.0695c0 4.365 3.6425 7.9514 8.0679 7.9304h3.7635Z" fill="#fff" /><path d="M15.0857 4.66138c-4.0438.00127-7.32056 3.27902-7.32151 7.32442.00095 4.0447 3.27771 7.3222 7.32151 7.3234 4.0448-.0012 7.3222-3.2787 7.3228-7.3234-.0006-4.0454-3.278-7.32315-7.3228-7.32442Zm-4.6409 7.32442c.0038-1.9768 1.2384-3.66251 2.9794-4.33238v8.66378c-1.741-.6695-2.9756-2.3543-2.9794-4.3314Zm6.3019 4.3333V7.65314c1.7416.66825 2.9781 2.35486 2.9812 4.33266-.0031 1.9784-1.2396 3.6638-2.9812 4.3333Z" fill="#0079BE" /></svg>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M15.0712 0c.0253.281017.0081.581568-.0565.894128L10.2242 23.3075c-.0512.239-.1277.4709-.22551.6925H4.12121C1.84513 24 0 22.1313 0 19.8261V4.17391C0 1.86872 1.84513 0 4.12121 0H15.0712Z" fill="#E21836" /><path fillRule="evenodd" clipRule="evenodd" d="M7.31804 24c-.00296-.2216.01997-.4536.0712-.6926L12.1797.894032c.067-.312524.1771-.613042.3219-.894032h15.3851c-.0043.0171633-.0087.0343995-.0131.0517068-.0677.2660402-.1396.5488902-.2002.8423252L22.8829 23.3074c-.0512.239-.0925.471-.1306.6926H7.31804Z" fill="#00447C" /><path fillRule="evenodd" clipRule="evenodd" d="M19.8819 24c-.003-.2216.02-.4536.0712-.6926L24.7436.894032c.067-.312524.1771-.613042.3218-.894032h4.8134C32.1549 0 34 1.86872 34 4.17391V19.8261C34 22.1313 32.1549 24 29.8788 24h-9.9969Z" fill="#007B84" /><path d="M8.01382 6.98846c-.84752.0089-1.09782 0-1.17777-.01945-.03073.15046-.60265 2.86844-.60425 2.87072-.12314.54987-.21274.94187-.51707 1.19497-.17276.1472-.37445.2181-.60828.2181-.37585 0-.59481-.1922-.63157-.5569l-.00703-.1252s.1145-.73656.1145-.7407c0 0 .60024-2.47688.70771-2.80428.00562-.01863.00723-.02836.00864-.03726-1.16833.01056-1.37544 0-1.38971-.01945-.00783.0267-.03676.18026-.03676.18026l-.61289 2.79166-.05263.23677-.10185.7744c0 .2298.04379.4173.13098.5758.27922.5027 1.07572.578 1.5263.578.58055 0 1.12514-.1271 1.49316-.3591.6388-.3888.80594-.9967.95499-1.5368l.06911-.27714s.61831-2.57249.72337-2.90714c.00402-.01863.00563-.02836.01105-.03726Zm2.10378 2.07526c-.14905 0-.42145.03725-.66612.1608-.08879.04698-.17276.10121-.26135.15522l.07995-.2974-.04379-.05008c-.51888.10824-.63499.12273-1.1143.19226l-.04017.02753c-.05565.47538-.10506.83275-.31137 1.76725-.07854.3443-.1601.692-.24186 1.0356l.02209.0437c.49116-.0267.64022-.0267 1.06709-.0195l.03455-.0387c.05424-.2862.06127-.3533.1814-.933.05645-.2748.17416-.8787.23222-1.0937.10667-.05096.21193-.10104.31237-.10104.23925 0 .21013.21504.20088.30074-.01024.1438-.09742.6136-.18682 1.017l-.05966.2603c-.04158.1923-.08718.3792-.12876.5698l.01808.0381c.48412-.0267.63177-.0267 1.04517-.0195l.0486-.0387c.0748-.447.0967-.5667.2292-1.2175l.0667-.2991c.1296-.58527.1947-.88205.0967-1.12378-.1037-.2709-.3524-.3363-.5808-.3363Zm2.3502.61278c-.2574.05091-.4215.08485-.5846.10679-.1617.0267-.3194.05091-.5681.08651l-.0197.01842-.0181.01469c-.0259.19079-.044.35579-.0783.54969-.0291.2005-.0739.4284-.1469.7558-.0564.2506-.0855.338-.1177.4261-.0313.0882-.0659.1739-.1293.4204l.0148.0227.0125.0209c.2324-.0113.3845-.0194.5408-.0209.156-.0058.3178 0 .5681.0015l.0218-.0184.0236-.0203c.0361-.2223.0415-.2821.0636-.3906.0219-.1163.0597-.2773.1523-.7073.0438-.202.0926-.4034.138-.6095.0472-.2053.0966-.40753.1436-.60952l-.007-.02442-.0094-.02256Zm.0054-.82622c-.2338-.14218-.6442-.09706-.9204.09934-.2754.19247-.3067.46566-.0737.6097.2298.13825.6418.09706.9156-.10099.2748-.19662.3092-.46732.0785-.60805Zm1.4142 3.29282c.473 0 .958-.1343 1.323-.5329.2808-.3233.4096-.8043.4542-1.0023.1452-.6565.0321-.963-.1099-1.14968-.2158-.28457-.597-.37583-.9926-.37583-.2378 0-.8043.02421-1.2469.44454-.3177.3032-.4646.71467-.5532 1.10907-.0894.4019-.1922 1.1255.4536 1.3947.1993.0882.4865.1124.6718.1124Zm-.037-1.4771c.1091-.4971.2378-.91431.5665-.91431.2575 0 .2762.31041.1617.80921-.0205.1107-.1145.5224-.2417.6977-.0888.1293-.1938.2077-.3099.2077-.0346 0-.2401 0-.2433-.3143-.0016-.1553.0291-.3138.0667-.486Zm2.9968 1.4132.0369-.0387c.0525-.2863.0611-.3535.1772-.933.0581-.2748.1782-.8788.2346-1.0938.1069-.0511.2104-.10118.314-.10118.2377 0 .2087.21498.1993.30068-.0087.1441-.0958.6137-.1868 1.017l-.0565.2604c-.0432.1924-.0902.3791-.1318.5699l.0181.0381c.4858-.0267.6278-.0267 1.0436-.0194l.0502-.0387c.0729-.4473.0926-.5669.2292-1.2176l.0651-.2992c.1302-.58531.1961-.88189.0997-1.12361-.1067-.27091-.357-.33631-.5822-.33631-.1493 0-.4231.03705-.6663.16081-.087.04698-.1742.10099-.2598.15522l.0746-.2974-.04-.05029c-.5187.10844-.6372.12293-1.1159.19247l-.0368.02752c-.058.47539-.1052.83259-.3116 1.76719-.0785.3444-.1601.6921-.2416 1.0356l.0219.0437c.4919-.0267.6388-.0267 1.0649-.0194Zm3.5687.0193c.0306-.1535.212-1.0638.2136-1.0638 0 0 .1545-.6678.1639-.692 0 0 .0486-.0696.0972-.0971h.0715c.6748 0 1.4367 0 2.034-.4526.4064-.31044.6842-.76885.8081-1.32598.0322-.1366.0559-.29906.0559-.46152 0-.21338-.0416-.42447-.1617-.58942-.3046-.43896-.9111-.44703-1.6111-.45034-.0022 0-.3451.00331-.3451.00331-.8962.01138-1.2556.00807-1.4032-.01055-.0125.06726-.036.18688-.036.18688s-.321 1.53273-.321 1.53522c0 0-.7681 3.2588-.8043 3.4123.7824-.0097 1.1032-.0097 1.2382.0056Zm.5948-2.72273s.3413-1.52963.3397-1.52383l.0111-.07844.0048-.05981.1364.01448s.7039.0623.7204.06395c.2778.11073.3923.39612.3123.76865-.0729.34044-.2872.62667-.5626.76492-.2268.11713-.5046.12686-.7909.12686h-.1852l.014-.07678Zm2.1251 1.31863c-.0902.3961-.1939 1.1196.4487 1.3775.2049.0898.3885.1165.5752.1068.197-.011.3796-.1128.5488-.2594-.0153.0603-.0306.1205-.0458.1809l.0291.0387c.4622-.02.6057-.02 1.1065-.0161l.0454-.0356c.0731-.4429.142-.873.332-1.7202.0926-.40589.185-.8078.28-1.21199l-.0148-.0445c-.5171.09872-.6553.11983-1.1527.19247l-.0378.03167c-.005.04118-.0102.08071-.015.12024-.0774-.12873-.1895-.23862-.3624-.30713-.2212-.08961-.7407.02587-1.1872.44476-.3138.29905-.4645.70878-.55 1.10188Zm1.0859.0242c.1107-.4882.2379-.90133.5673-.90133.2083 0 .318.19803.2957.53583-.0177.0842-.0367.173-.0594.2734-.033.1451-.0687.2889-.1035.4329-.0354.0985-.0765.1915-.1217.2534-.0848.1237-.2865.2005-.4026.2005-.0329 0-.2362 0-.2433-.3088-.0016-.1538.0292-.3121.0675-.4859Zm5.671-1.61204-.0399-.04698c-.5117.10679-.6043.12376-1.0744.18916l-.0345.0356c-.0016.00579-.003.01469-.0054.02276l-.0016-.00807c-.35.83177-.3397.65233-.6246 1.30717-.0016-.0298-.0016-.0485-.0032-.0801l-.0713-1.41954-.0448-.04698c-.536.10679-.5486.12376-1.0436.18916l-.0386.0356c-.0054.01697-.0054.03559-.0086.05587l.0032.00725c.0619.32575.047.25311.1091.76724.0289.2522.0675.506.0964.7551.0488.4171.0762.6224.1358 1.2588-.3343.5683-.4134.7833-.7352 1.2821l.0022.0049-.2266.3693c-.0259.0389-.0494.0656-.0824.0769-.0361.0185-.0831.0218-.1484.0218h-.1256l-.1866.6395.6402.0114c.3759-.0017.6121-.1828.7393-.4262l.4025-.7107h-.0064l.0424-.0501c.2708-.6005 2.3306-4.24094 2.3306-4.24094Zm-6.757 8.39884h-.2716l1.0053-3.4253h.3334l.1059-.3529.0102.3924c-.0124.2426.1728.4576.6593.422h.5627l.1937-.6596h-.2118c-.1217 0-.1782-.0316-.1711-.0995l-.0103-.3993h-1.0419v.0021c-.3369.0073-1.3429.0333-1.5466.0892-.2465.0654-.5063.2579-.5063.2579l.1021-.3533h-.9747l-.2031.701-1.0187 3.4777h-.1976l-.1939.6548h1.9413l-.065.2184h.9566l.0634-.2184h.2684l.2103-.7072Zm-.7965-2.7293c-.156.0445-.4465.1794-.4465.1794l.2583-.8754h.7744l-.1868.6378s-.2393.0145-.3994.0582Zm.0149 1.2506s-.2433.0315-.4034.0687c-.1577.0493-.4534.2045-.4534.2045l.2668-.911h.7784l-.1884.6378Zm-.4339 1.4868h-.7768l.2252-.7688h.7744l-.2228.7688Zm1.8707-2.1246h1.1198l-.161.5368h-1.1345l-.1704.587h.9928l-.7517 1.0904c-.0527.0801-.0999.1085-.1523.131-.0526.0276-.1217.0598-.2017.0598h-.2754l-.1892.6429h.7203c.3745 0 .5957-.1755.759-.4059l.5154-.7268.1107.738c.0235.1382.12.2192.1852.2506.0722.0373.1467.1012.2519.1107.1129.005.1945.0089.2487.0089h.354l.2125-.7194h-.1396c-.0801 0-.2181-.0138-.2416-.0397-.0235-.0314-.0236-.0799-.0362-.1536l-.1123-.7396h-.4598l.2017-.2473h1.1323l.1742-.587h-1.0484l.1633-.5368h1.0452l.1939-.6621h-3.1161l-.1907.6621Zm-9.4571 2.2741.2613-.8957h1.0741l.1963-.6662h-1.0751l.1641-.5514h1.0506l.1947-.645H13.571l-.1906.645h.5972l-.1593.5514h-.5988l-.1985.6776h.597l-.3483 1.185c-.047.1569.0221.2167.0659.2895.0448.071.0902.118.1922.1447.1053.0242.1774.0387.2754.0387h1.2109l.2158-.738-.5368.076c-.1036 0-.3907-.0129-.3593-.1116Zm.1232-4.2879-.2722.5068c-.0583.1107-.1107.1794-.1579.2111-.0416.0267-.124.0379-.2433.0379h-.142l-.1899.6484h.4717c.2268 0 .401-.0857.4841-.1285.0894-.0493.1129-.0211.182-.0899l.1593-.1421h1.4729l.1955-.6751H15.339l.1883-.3686H14.457Zm2.1744 4.3009c-.0251-.0372-.007-.1028.0313-.2394l.4026-1.3728h1.4321c.2087-.0031.3594-.0056.4574-.0128.1053-.0114.2198-.0501.3445-.1196.1288-.0729.1947-.1497.2503-.2378.0621-.088.1617-.2805.2473-.5772l.506-1.7372-1.4861.0089s-.4576.0695-.6591.1463c-.2033.0856-.4938.3249-.4938.3249l.1342-.4762h-.918l-1.2853 4.3914c-.0456.1706-.0761.2943-.0832.3686-.0023.0801.0981.1594.1632.2192.0769.0598.1906.0501.2997.0598.1147.0089.2778.0145.503.0145h.7055l.2166-.7533-.6316.0614c-.0675 0-.1163-.0372-.1366-.0687Zm.6936-2.5394h1.5042l-.0956.3088c-.0134.0073-.0456-.0153-.1986.0033h-1.3026l.0926-.3121Zm.3014-1.0356h1.5168l-.1091.3719s-.7149-.0072-.8294.0145c-.5038.0898-.7981.3672-.7981.3672l.2198-.7536Zm1.1409 2.3784c-.0125.0462-.0321.0743-.0597.0955-.0305.0202-.0799.0275-.1536.0275h-.2144l.0127-.3761h-.8915l-.0362 1.8384c-.0014.1327.011.2095.1053.271.0942.0767.3844.0865.7752.0865h.5586l.2017-.6882-.4863.0276-.1617.0097c-.0221-.0097-.0432-.0186-.0667-.0429-.0205-.0209-.0551-.008-.0495-.1407l.0039-.4712.51-.0218c.2754 0 .3931-.0923.4936-.1802.0958-.0843.1271-.1811.1633-.3121l.0856-.4172h-.7009l-.0894.2942Z" fill="#FEFEFE" /></svg>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#fff" /><path fillRule="evenodd" clipRule="evenodd" d="M30 1H4C2.34315 1 1 2.34315 1 4v16c0 1.6569 1.34315 3 3 3h26c1.6569 0 3-1.3431 3-3V4c0-1.65685-1.3431-3-3-3ZM4 0C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4H4Z" fill="#000" /><path d="M9.00201 8.55144c.3061-.38287.51383-.89696.45904-1.42229-.4481.02228-.99491.29563-1.31149.6788-.28426.32813-.53585.86374-.47026 1.36705.50302.04363 1.00556-.25143 1.32271-.62356ZM9.45529 9.27318c-.73049-.04351-1.35159.41459-1.70044.41459-.34904 0-.88324-.39266-1.46102-.38208-.75202.01104-1.44981.43624-1.83143 1.11251-.78492 1.3529-.20714 3.3596.55616 4.4615.37067.5451.8174 1.1453 1.40603 1.1237.55615-.0218.77414-.3601 1.45017-.3601.67554 0 .8719.3601 1.46063.3492.61052-.0109.99221-.5454 1.36291-1.091.4252-.6214.5993-1.2214.6102-1.2544-.0109-.0109-1.1772-.4583-1.1881-1.7999-.011-1.1234.9157-1.6577.9593-1.6908-.5233-.77402-1.34094-.86129-1.62441-.88322ZM15.8159 7.75293c1.5877 0 2.6933 1.09443 2.6933 2.68787 0 1.5991-1.1284 2.6992-2.7331 2.6992h-1.758v2.7955h-1.27V7.75293h3.0678Zm-1.7978 4.32097h1.4574c1.1058 0 1.7351-.5954 1.7351-1.6274 0-1.03202-.6293-1.62178-1.7294-1.62178h-1.4631v3.24918ZM18.841 14.24c0-1.0434.7995-1.6842 2.2173-1.7636l1.633-.0963v-.4593c0-.6635-.448-1.0604-1.1964-1.0604-.709 0-1.1513.3401-1.2589.8732h-1.1568c.068-1.0774.9866-1.8713 2.461-1.8713 1.446 0 2.3702.7655 2.3702 1.962v4.1112h-1.1738v-.981h-.0283c-.3458.6634-1.1001 1.083-1.8826 1.083-1.1681 0-1.9847-.7258-1.9847-1.7975Zm3.8503-.5387v-.4706l-1.4687.0907c-.7316.051-1.1454.3742-1.1454.8846 0 .5216.4309.8619 1.0887.8619.8562 0 1.5254-.5898 1.5254-1.3666ZM25.0187 18.1299v-.9923c.0905.0226.2946.0226.3968.0226.567 0 .8732-.2381 1.0603-.8505 0-.0114.1078-.3629.1078-.3686l-2.1547-5.97113h1.3267l1.5086 4.85403h.0225l1.5085-4.85403h1.2929l-2.2344 6.27723c-.5101 1.4461-1.0999 1.9111-2.3361 1.9111-.1021 0-.4084-.0114-.4989-.0284Z" fill="#000" /></svg>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#fff" /><path fillRule="evenodd" clipRule="evenodd" d="M30 1H4C2.34315 1 1 2.34315 1 4v16c0 1.6569 1.34315 3 3 3h26c1.6569 0 3-1.3431 3-3V4c0-1.65685-1.3431-3-3-3ZM4 0C1.79086 0 0 1.79086 0 4v16c0 2.2091 1.79086 4 4 4h26c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4H4Z" fill="#3C4043" /><path d="M15.9499 13.2072v3.239h-1.028V8.44775h2.7251c.6906 0 1.2795.23022 1.7614.69064.4925.46042.7388 1.02251.7388 1.68641 0 .6799-.2463 1.2421-.7388 1.6971-.4765.4551-1.0654.68-1.7614.68h-1.6971v.0053Zm0-3.77436v2.78926h1.7185c.4069 0 .7495-.1392 1.0172-.4122.2731-.273.4123-.605.4123-.9797 0-.3694-.1392-.696-.4123-.96906-.2677-.28375-.6049-.42295-1.0172-.42295h-1.7185v-.00535ZM22.8347 10.7925c.7603 0 1.3599.2034 1.7989.6103.439.4069.6585.9637.6585 1.6704v3.3728h-.9797v-.7602h-.0429c-.4229.6264-.9904.9369-1.6971.9369-.605 0-1.1082-.1767-1.5151-.5354-.4069-.3587-.6103-.803-.6103-1.3384 0-.5675.2141-1.0172.6424-1.3492.4283-.3372 1.0012-.5032 1.7132-.5032.6103 0 1.1136.1124 1.5044.3373v-.2356c0-.3587-.1392-.6585-.4229-.9101-.2838-.2516-.6157-.3748-.9958-.3748-.5729 0-1.0279.2409-1.3599.7281l-.9048-.5675c.4979-.7227 1.2368-1.0814 2.2111-1.0814Zm-1.3277 3.9724c0 .2677.1124.4926.3426.6693.2249.1766.4926.2676.7978.2676.4336 0 .8191-.1606 1.1564-.4818.3373-.3212.5086-.696.5086-1.1296-.3213-.2516-.7656-.3801-1.3385-.3801-.4176 0-.7656.1017-1.0439.2998-.2838.2088-.423.4604-.423.7548ZM30.8814 10.9692l-3.4264 7.8807h-1.06l1.2742-2.7571-2.2593-5.1236h1.1189l1.6276 3.9297h.0214l1.5847-3.9297h1.1189Z" fill="#3C4043" /><path d="M11.8612 12.5538c0-.3351-.03-.6558-.0857-.9642H7.46683v1.7667l2.48145.0006c-.10065.5878-.42455 1.0889-.92084 1.423v1.1462h1.47706c.8625-.7982 1.3567-1.9782 1.3567-3.3723Z" fill="#4285F4" /><path d="M9.02796 14.78c-.41117.2773-.94065.4395-1.56008.4395-1.19655 0-2.21162-.8063-2.57514-1.8931H3.36907v1.1821c.75488 1.498 2.30639 2.5259 4.09881 2.5259 1.23885 0 2.27962-.4074 3.03722-1.1087L9.02796 14.78Z" fill="#34A853" /><path d="M4.74927 12.4495c0-.3052.05086-.6002.14348-.8775v-1.1821H3.36908c-.31212.6194-.48772 1.3186-.48772 2.0596 0 .7409.17613 1.4401.48772 2.0596l1.52367-1.1821c-.09262-.2774-.14348-.5724-.14348-.8775Z" fill="#FABB05" /><path d="M7.46788 9.67893c.67618 0 1.28168.23288 1.75977.68797l1.30895-1.30793c-.79499-.74042-1.83147-1.19496-3.06872-1.19496-1.79189 0-3.34393 1.02792-4.09881 2.52589l1.52367 1.1821c.36352-1.0868 1.37859-1.89307 2.57514-1.89307Z" fill="#E94235" /></svg>;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <svg className="PaymentLogo " width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4c0-2.20914 1.79086-4 4-4h26c2.2091 0 4 1.79086 4 4v16c0 2.2091-1.7909 4-4 4H4c-2.20914 0-4-1.7909-4-4V4Z" fill="#353E48" /><path d="m12.2469 6-.1393.02344c-.4361.05467-.8565.21778-1.2058.48179-.078.04667-.148.10921-.2253.17188-.008-.01534-.0156-.03154-.0156-.04688-.016-.086-.0237-.17833-.0391-.26433-.0233-.14001-.1009-.21095-.2409-.21095h-.3659c-.22531 0-.26431.04763-.26431.26564v6.75021c.008.1014.06962.1548.15496.1628h.67715c.0933 0 .1476-.0614.1549-.1628.008-.0313.0078-.0624.0078-.0937v-2.3452c.0314.0314.055.0472.0703.0625.5681.4747 1.2216.6297 1.9376.4896.6534-.132 1.104-.5286 1.392-1.112.2253-.44332.3175-.89412.3255-1.38414.0154-.53668-.0312-1.0533-.2565-1.55865-.2647-.62202-.7153-1.03451-1.392-1.17452-.1013-.02333-.2099-.03154-.3112-.04688-.0933-.008-.179-.00781-.2643-.00781Zm5.1812 0c-.0314.008-.0612.01563-.0925.01563-.3113.01533-.6153.05418-.918.13151-.1947.04667-.381.11639-.5677.17839-.1167.03867-.1719.12471-.1719.24871.008.10134 0 .20987 0 .31121.008.15534.0707.19559.2188.15626.2486-.06201.4974-.13173.7461-.1784.3887-.07.7856-.10154 1.1823-.04687.21.03866.4045.09347.5365.27214.1167.14801.1639.33418.1719.52085.008.26468.0078.4743.0078.73831 0 .01534.0002.03043-.0078.03776h-.0391c-.3347-.08533-.6762-.13161-1.0183-.15495-.358-.01533-.7153.00033-1.0573.12501-.412.14-.7474.38831-.9414.79299-.148.31135-.1717.63868-.125.97265.07.4514.2882.7932.6849 1.0105.3813.21.7857.2326 1.2058.1706.482-.07.9092-.272 1.2826-.5834.0153-.0153.0315-.0224.0468-.0377.0234.1246.0392.2416.0625.3502.0154.1014.0786.1626.1719.1706h.5209c.078 0 .1484-.0696.1484-.1549.008-.0234.0078-.0553.0078-.086V7.64199c-.002-.13267-.0105-.27296-.0338-.40496-.062-.41202-.2335-.75469-.6068-.9727-.21-.12467-.4428-.1866-.6915-.22527-.1166-.016-.2257-.02373-.3424-.03906h-.3815Zm2.6967.0013c-.078 0-.1169.06914-.1016.14714.0153.06267.0392.13332.0625.19532.622 1.54006 1.2516 3.07909 1.8816 4.62644.0547.132.062.2417 0 .3737-.1007.2327-.1869.4738-.2956.7071-.0933.21-.2484.3664-.4818.4284-.1553.0393-.3262.0546-.4896.0313-.078-.008-.1564-.0233-.2344-.0313-.1093-.008-.1625.0383-.1705.155v.3125c.008.1793.0622.2564.2408.2877.1714.0307.3499.0532.5365.0612.544.0074.9727-.2089 1.2527-.6836.1166-.1867.2102-.3813.2956-.5833.754-1.9054 1.5007-3.80298 2.2474-5.71639.0234-.05467.0376-.10988.0456-.17188.0153-.09334-.0312-.13936-.1159-.13803h-.6289c-.1087-.008-.21.06143-.2487.16277-.0153.04667-.0316.08485-.0469.13152l-1.112 3.1811c-.078.22534-.1642.45838-.2422.70711-.016-.0394-.0233-.0548-.0313-.0782-.412-1.13535-.8159-2.26968-1.2279-3.40505-.062-.18667-.1318-.36692-.2018-.54559-.0307-.08601-.1018-.14714-.2031-.14714-.2414-.00801-.4819-.00782-.7305-.00782Zm-7.8857.80732c.4747.03867.8631.27223 1.0651.82425.1247.34202.1563.67198.1563 1.02999 0 .33468-.0231.63057-.1237.94925-.218.67669-.7162.94089-1.3543.91019-.4513-.0233-.8321-.1953-1.1901-.444-.0387-.0234-.062-.061-.0547-.10029V7.33729c-.0073-.04667.016-.08474.0547-.10808.4353-.30334.9173-.45925 1.4467-.42059Zm5.0457 2.10034c.1332-.01167.2674-.00916.3998.00651.2647.02334.5296.06941.7943.10808.0546.008.069.03146.069.07813-.008.156 0 .30364 0 .45965 0 .15534-.0078.29583-.0078.45187.008.0386-.0156.0691-.0469.0924-.358.2567-.7468.4286-1.1901.4753-.1787.0153-.358.0153-.5287-.0547-.1947-.07-.3412-.2337-.3959-.4284-.062-.202-.0618-.41192-.0078-.6146.0854-.26468.2715-.41141.5209-.49741.1283-.039.2601-.06516.3932-.07683Z" fill="#fff" /><path d="M23.7799 14.5395c.5573-.391 1.2918-.5304 1.9141-.5391.6223-.0086 1.1313.1132 1.2383.2448.2134.2634-.0576 2.0942-1.1003 2.9676-.1607.1333-.3129.0607-.2409-.1146l.0112-.0283c.2379-.6009.744-1.8795.498-2.1931-.2484-.3174-1.6329-.151-2.2633-.0752l-.0077.0009c-.1913.022-.2214-.1436-.0494-.263Z" fill="#FB981F" /><path d="M7.08784 15.0174c-.15201-.146-.08939-.3303.05599-.3503.04846-.0066.1063.0057.16797.043 2.8174 1.7061 6.3 2.4571 9.8975 2.4571 2.4274 0 5.0943-.5221 7.5498-1.6055.3713-.1653.6797.2532.3177.5326-2.1901 1.68-5.3626 2.5717-8.0954 2.5717-3.8314 0-7.28213-1.1992-9.89356-3.6486Z" fill="#FB981F" /></svg>;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="font-lealti-light text-black"><figure className="flex flex-wrap gap-4">{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}<svg className="PaymentLogo variant--Card " width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.9381 0H4.08247C1.82779 0 0 1.82779 0 4.08247V19.9175C0 22.1722 1.82779 24 4.08247 24H29.9381C32.1928 24 34.0206 22.1722 34.0206 19.9175V4.08247C34.0206 1.82779 32.1928 0 29.9381 0Z" fill="#00D64F" /><path fillRule="evenodd" clipRule="evenodd" d="M17.5118 8.10454C18.6497 8.10454 19.7404 8.56532 20.4531 9.19781C20.6332 9.35782 20.903 9.35685 21.0722 9.18543L21.92 8.32548C22.099 8.14397 22.0925 7.84678 21.8993 7.68092C21.3303 7.19179 20.5664 6.71081 19.6263 6.40287L19.8923 5.13654C19.9499 4.86054 19.7397 4.60115 19.4576 4.60115H17.8191C17.6096 4.60115 17.4283 4.74779 17.3847 4.95276L17.1452 6.07895C14.9671 6.18779 13.1211 7.27456 13.1211 9.50446C13.1211 11.4349 14.6484 12.2623 16.2605 12.8348C17.7878 13.4073 18.5937 13.6199 18.5937 14.4257C18.5937 15.2531 17.7878 15.7409 16.5997 15.7409C15.5165 15.7409 14.3818 15.3834 13.5014 14.5153C13.3287 14.3448 13.0523 14.3436 12.8796 14.5139L11.9685 15.4127C11.7902 15.5884 11.7919 15.8771 11.9714 16.0511C12.6818 16.7406 13.5812 17.2399 14.6077 17.5195L14.3577 18.6925C14.2994 18.9677 14.5076 19.227 14.7892 19.2293L16.4302 19.2417C16.6414 19.2433 16.8249 19.0957 16.8679 18.8887L17.1048 17.761C19.7127 17.5999 21.3088 16.1824 21.3088 14.1077C21.3088 12.1987 19.7182 11.3925 17.7878 10.7349C16.6847 10.3315 15.7299 10.0561 15.7299 9.2291C15.7299 8.42323 16.6212 8.10454 17.5118 8.10454Z" fill="white" /></svg></figure></div>;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t2) {
    t15 = <div className="flex flex-col gap-6">{t2}{t14}</div>;
    $[14] = t2;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
};
const ProductInfoTab = t0 => {
  const $ = _c(25);
  const {
    product
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="font-semibold">Material</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = product.material ? product.material : "-";
  let t3;
  if ($[1] !== t2) {
    t3 = <div>{t1}<p>{t2}</p></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-semibold">Country of origin</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = product.origin_country ? product.origin_country : "-";
  let t6;
  if ($[4] !== t5) {
    t6 = <div>{t4}<p>{t5}</p></div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-semibold">Type</span>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = product.type ? product.type.value : "-";
  let t9;
  if ($[7] !== t8) {
    t9 = <div>{t7}<p>{t8}</p></div>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t3 || $[10] !== t6 || $[11] !== t9) {
    t10 = <div className="flex flex-col gap-y-4">{t3}{t6}{t9}</div>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-semibold">Weight</span>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = product.weight ? `${product.weight} g` : "-";
  let t13;
  if ($[14] !== t12) {
    t13 = <div>{t11}<p>{t12}</p></div>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="font-semibold">Dimensions</span>;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = product.length && product.width && product.height ? `${product.length}L x ${product.width}W x ${product.height}H` : "-";
  let t16;
  if ($[17] !== t15) {
    t16 = <div>{t14}<p>{t15}</p></div>;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t13 || $[20] !== t16) {
    t17 = <div className="flex flex-col gap-y-4">{t13}{t16}</div>;
    $[19] = t13;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t10 || $[23] !== t17) {
    t18 = <div className="text-small-regular py-8"><div className="grid grid-cols-2 gap-x-8">{t10}{t17}</div></div>;
    $[22] = t10;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  return t18;
};
const HowToBuy = t0 => {
  const $ = _c(2);
  const {
    product
  } = t0;
  const displayName = product?.name ?? product?.title ?? "este producto";
  const brandName = product?.brand?.name ?? "la marca";
  const t1 = `Compra online ${displayName} de ${brandName} en nuestra tienda on-line, puedes pagar tu compra con todas las tarjetas de débito, crédito, transferencias bancarias o medios de pago en efectivo. Agrega ${displayName} al carrito de compras, completa tus datos de envío y elige el método de pago que más te convenga. Una vez finalizada tu compra, recibirás un correo electrónico con la confirmación del pedido y los detalles de tu compra.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-md"><div className="grid grid-cols-1"><div className="flex items-start gap-x-2"><p className="max-w-full font-lealti-light text-black">{t1}</p></div></div></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
const ShippingInfoTab = t0 => {
  const $ = _c(2);
  const {
    product
  } = t0;
  const displayName = product?.name ?? product?.title ?? "este producto";
  const brandName = product?.brand?.name ?? "la marca";
  const t1 = `Recibe tu ${displayName} de ${brandName} en tu domicilio entre 1 a 3 días hábiles con envíos nacionales o entre 5 a 10 días hábiles con envíos internacionales. También podés optar por retirar tu ${displayName} en nuestro showroom sin costo adicional seleccionando Pick-Up como método de envío. Podrás elegir el método de envío que más te convenga y conocer sus costos durante el proceso de checkout.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-md"><div className="grid grid-cols-1"><div className="flex items-start gap-x-2"><p className="max-w-full font-lealti-light text-black">{t1}</p></div></div></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
const ReturnPolicyTab = t0 => {
  const $ = _c(2);
  const {
    product
  } = t0;
  const displayName = product?.name ?? product?.title ?? "este producto";
  const brandName = product?.brand?.name ?? "la marca";
  const t1 = `${displayName} de ${brandName} cuenta con garantía por desperfectos de fábrica y puedes hacer la devolución sin costo dentro de un plazo máximo de 15 días corridos desde realizada tu compra. El producto devuelto deberá encontrarse sin uso, con todas sus etiquetas y packaging original.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-md"><div className="grid grid-cols-1"><div className="flex items-start gap-x-2"><p className="max-w-full font-lealti-light text-black">{t1}</p></div></div></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
const HelpTag = t0 => {
  const $ = _c(2);
  const {
    product
  } = t0;
  const displayName = product?.name ?? product?.title ?? "este producto";
  const brandName = product?.brand?.name ?? "la marca";
  const t1 = `¿Necesitás ayuda para comprar ${displayName} de ${brandName}? – Contactanos ahora por Whatsapp al +598 96 947 466, estamos para ayudarte con tu compra todos los días durante las 24 horas.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-md"><div className="grid grid-cols-1"><div className="flex items-start gap-x-2"><p className="max-w-full font-lealti-light text-black">{t1}</p></div></div></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
const ProductAdditionalInfoTab = t0 => {
  const $ = _c(4);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product.infoIds) {
    t1 = product.infoIds && product.infoIds.length > 0 && product.infoIds.map(_temp4);
    $[0] = product.infoIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="text-small-regular ">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ProductTabs;
function _temp(info) {
  const showsContent = info?.type !== "image" && info?.type !== "size-guide" && !!info?.content;
  const showsImage = info?.type !== "text" && info?.type !== "size-guide" && !!info?.imageUrl;
  return showsContent || showsImage;
}
function _temp2(tab, i) {
  return <Accordion.Item key={i} title={tab.label} headingSize="medium" value={tab.label} icon={tab.icon}>{tab.component}</Accordion.Item>;
}
function _temp3(review) {
  return <div key={review.id} className="rounded-xl border border-gray-200 p-4"><div className="flex flex-wrap items-center justify-between gap-2"><RatingStars value={review.overallRating || 0} size="sm" readOnly={true} />{review.verifiedPurchase ? <span className="rounded-full bg-green-50 px-2 py-0.5 text-xs font-semibold text-green-700">Compra verificada</span> : null}</div><p className="mt-2 text-sm text-gray-700">{review.comment || "Sin comentario."}</p><p className="mt-1 text-xs text-gray-500">{review.createdAt ? new Date(review.createdAt).toLocaleDateString("es-UY") : ""}</p></div>;
}
function _temp4(info) {
  return <div key={info._id}>{info.title && <div>{info.subtitle && <Text className="text-xs text-gray-500 uppercase tracking-wide">{info.subtitle}</Text>}</div>}{info.type !== "image" && info.type !== "size-guide" && info.content && <Text className="text-sm text-black leading-relaxed whitespace-pre-line">{info.content}</Text>}{info.type !== "text" && info.type !== "size-guide" && info.imageUrl && <div className="relative mt-4 w-full overflow-hidden rounded-lg"><Image src={info.imageUrl} alt={info.title || ""} fill={true} className="object-cover" sizes="(min-width: 1024px) 420px, 90vw" /></div>}</div>;
}